import { Spinner } from "components/shared/Spinner";
import { FC, ReactNode, VFC } from "react";
import { MessageDescriptor, useIntl } from "react-intl";
import { Message } from "shared/components/Message";
import { mapMessages } from "shared/mapMessages";

const messages = mapMessages("components.shared.LoadingRegion", {
    errorText: "Failed to load {contentName}.",
    loadingText: "Loading {contentName}.",
    successText: "Successfully loaded {contentName}."
});

type Props = {
    children: ReactNode,
    contentName: MessageDescriptor;
    hasError: boolean;
    isLoading: boolean;
};

export const LoadingRegion: VFC<Props> = ({
    children,
    contentName,
    hasError,
    isLoading,
}) => {
    const intl = useIntl();
    const messageValues: { contentName: string } = { contentName: intl.formatMessage(contentName) };

    const shouldRenderError = hasError;
    const shouldRenderLoading = isLoading && !hasError;
    const shouldRenderSuccess = !isLoading && !hasError;

    return <>
        <div role="status" aria-live="assertive">
            {shouldRenderError && <div className="sr-only"><Message message={messages.errorText} values={messageValues} /></div>}
        </div>
        <div role="status" aria-live="polite">
            {shouldRenderLoading && <div><Spinner className="mr-1" aria-hidden="true" /> <Message message={messages.loadingText} values={messageValues} /></div>}
            {shouldRenderSuccess && <div className="sr-only"><Message message={messages.successText} values={messageValues} /></div>}
        </div>
        <div aria-busy={shouldRenderLoading}>
            {children}
        </div>
    </>;
};
